import ACTIONS from '../actionTypes/notification'
import NotificationStatus from '../../constants/notificationStatus'

const initialState = {
    allNotifications: [],
    unreadIds: [],
    pushNotifications: []
}

const notification = (state = initialState, action) => {

    switch (action.type) {
        case ACTIONS.GET_ALL_NOTIFCATION_SUCCESS:
            const unReadIds = Array.isArray(action?.payload) ? action?.payload?.filter(s => s.statusCode === NotificationStatus.NEW)?.map(s => s.id) : [];
            return {
                ...state,
                allNotifications: action.payload,
                unreadIds: unReadIds
            }
        case ACTIONS.RECEIVE_NOTIFCATION:
            return {
                ...state,
                allNotifications: [action?.payload, ...state.allNotifications],
                unreadIds: [...state.unreadIds, action.payload.id],
                pushNotifications: [action?.payload, ...state?.pushNotifications]

            }
        case ACTIONS.MARK_ALL_AS_READ:
            return {
                ...state,
                unreadIds: state.unreadIds.filter(id=>!action.payload.includes(id))
            }
        case ACTIONS.DISMISS_PUSH_NOTIFICATION:
            return {
                ...state,
                pushNotifications: state.pushNotifications.filter(s => s.id !== action.payload.id)
            }
        default: return state
    }
}

export default notification